// Mock data for MIA Atelier

export const heroImages = [
  "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmYXNoaW9ufGVufDB8fHx8MTc3MjQ2NTA0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1568251188392-ae32f898cb3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY291dHVyZXxlbnwwfHx8fDE3NzI0NjUwNTF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1768885560329-5a07715b4447?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwY291dHVyZXxlbnwwfHx8fDE3NzI0NjUwNTF8MA&ixlib=rb-4.1.0&q=85"
];

export const womensCouture = [
  {
    id: 1,
    name: "Ethereal Evening Gown",
    description: "Structured silhouette with handcrafted lace details",
    price: "$1,295",
    priceNGN: "₦1,950,000",
    image: "https://images.unsplash.com/photo-1568251188392-ae32f898cb3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Designed for a close, sculpted fit."
  },
  {
    id: 2,
    name: "Ivory Dreams Dress",
    description: "Satin and mesh with pearl embellishments",
    price: "$895",
    priceNGN: "₦1,350,000",
    image: "https://images.unsplash.com/photo-1736005706314-3b58fe2a45d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Structured at the bodice with a fluid skirt."
  },
  {
    id: 3,
    name: "Champagne Elegance",
    description: "Modern heirloom piece with delicate beading",
    price: "$1,495",
    priceNGN: "₦2,250,000",
    image: "https://images.unsplash.com/photo-1568251863885-adcac989de24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Designed for a close, sculpted fit."
  },
  {
    id: 4,
    name: "Rose Gold Reverie",
    description: "Flowing silhouette with intricate embroidery",
    price: "$1,195",
    priceNGN: "₦1,800,000",
    image: "https://images.unsplash.com/photo-1764998112680-2f617dc9be40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Designed with relaxed ease."
  },
  {
    id: 5,
    name: "Blush Cascade Gown",
    description: "Layered tulle with hand-stitched details",
    price: "$995",
    priceNGN: "₦1,500,000",
    image: "https://images.unsplash.com/photo-1763336016192-c7b62602e993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Structured at the bodice with a fluid skirt."
  },
  {
    id: 6,
    name: "Midnight Satin Masterpiece",
    description: "Refined elegance with structured bodice",
    price: "$1,395",
    priceNGN: "₦2,100,000",
    image: "https://images.unsplash.com/photo-1771254240466-fd789303324e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85",
    category: "women",
    fitNote: "Designed for a close, sculpted fit."
  }
];

export const girlsCouture = [
  {
    id: 7,
    name: "Little Princess Gown",
    description: "Delicate lace with soft tulle layers",
    price: "$495",
    priceNGN: "₦750,000",
    image: "https://images.unsplash.com/photo-1736005706314-3b58fe2a45d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85",
    category: "girls",
    fitNote: "Designed with relaxed ease."
  },
  {
    id: 8,
    name: "Heirloom Flower Girl",
    description: "Timeless design with pearl accents",
    price: "$595",
    priceNGN: "₦900,000",
    image: "https://images.unsplash.com/photo-1764998112680-2f617dc9be40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85",
    category: "girls",
    fitNote: "Structured at the bodice with a fluid skirt."
  },
  {
    id: 9,
    name: "Angel's Dream Dress",
    description: "Soft satin with handcrafted rosettes",
    price: "$695",
    priceNGN: "₦1,050,000",
    image: "https://images.unsplash.com/photo-1763336016192-c7b62602e993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85",
    category: "girls",
    fitNote: "Designed with relaxed ease."
  }
];

export const craftsmanshipImages = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1673201230274-c4dbd20c3f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwYXRlbGllcnxlbnwwfHx8fDE3NzI0NjUxMTJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Atelier Workspace",
    description: "Where every piece begins its journey"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1718963581743-10d76f92d42f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxzZXdpbmclMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc3MjQ2NTExNnww&ixlib=rb-4.1.0&q=85",
    title: "Precision & Detail",
    description: "Every stitch tells a story"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1621781727164-8121aec35c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxzZXdpbmclMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc3MjQ2NTExNnww&ixlib=rb-4.1.0&q=85",
    title: "Heritage Tools",
    description: "Traditional craftsmanship meets modern design"
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmYXNoaW9ufGVufDB8fHx8MTc3MjQ2NTA0Nnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1568251188392-ae32f898cb3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY291dHVyZXxlbnwwfHx8fDE3NzI0NjUwNTF8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1736005706314-3b58fe2a45d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1764998112680-2f617dc9be40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnb3dufGVufDB8fHx8MTc3MjQ2NTA4MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1673201230274-c4dbd20c3f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwYXRlbGllcnxlbnwwfHx8fDE3NzI0NjUxMTJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1768885560329-5a07715b4447?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwY291dHVyZXxlbnwwfHx8fDE3NzI0NjUwNTF8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const brandStory = {
  title: "A Legacy of Love & Craftsmanship",
  subtitle: "Mother & Daughter. Nigerian Heritage. Global Elegance.",
  content: "MIA Atelier was born from a shared passion between a mother and daughter for creating pieces that transcend time. Based in Nigeria, we blend traditional craftsmanship with contemporary design to create modern heirloom pieces. Every gown, every stitch, every embellishment is a testament to our commitment to excellence and our belief that true luxury lies in the details. We create not just dresses, but legacies—garments that will be treasured and passed down through generations.",
  image: "https://images.unsplash.com/photo-1621781727164-8121aec35c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxzZXdpbmclMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc3MjQ2NTExNnww&ixlib=rb-4.1.0&q=85"
};
